<script setup lang="ts">
import type { NavigationMenuRootEmits, NavigationMenuRootProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { NavigationMenuRoot, useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';

import NavigationMenuViewport from './NavigationMenuViewport.vue';

const props = defineProps<
	NavigationMenuRootProps & {
		class?: HTMLAttributes['class'];
		viewportClass?: HTMLAttributes['class'];
	}
>();

const emits = defineEmits<NavigationMenuRootEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<NavigationMenuRoot
		v-bind="forwarded"
		:class="
			cn(
				'navigation-menu-root relative z-10 flex max-w-max flex-1 items-center justify-center cursor-pointer',
				props.class
			)
		"
	>
		<slot />
		<NavigationMenuViewport :class="viewportClass" />
	</NavigationMenuRoot>
</template>
